export var Illustrations;
(function (Illustrations) {
    Illustrations["OTHER_DARK_VADOR"] = "otherDarkVador";
    Illustrations["OTHER_EXCEL"] = "otherExcel";
    Illustrations["OTHER_FIGMA"] = "otherFigma";
    Illustrations["OTHER_ROCKET"] = "otherRocket";
    Illustrations["OTHER_ROOFTOP"] = "otherRooftop";
    Illustrations["OTHER_STORY_BOOK"] = "otherStoryBook";
    Illustrations["OTHER_ZERO_HEIGHT"] = "otherZeroHeight";
    Illustrations["ACCESSIBILITY"] = "accessibility";
    Illustrations["AT_YOUR_SERVICE"] = "atYourService";
    Illustrations["BACKERY_LARGE"] = "backeryLarge";
    Illustrations["BACKERY_MEDIUM"] = "backeryMedium";
    Illustrations["BACKERY_SMALL"] = "backerySmall";
    Illustrations["BAR1LARGE"] = "bar1Large";
    Illustrations["BAR1MEDIUM"] = "bar1Medium";
    Illustrations["BAR1SMALL"] = "bar1Small";
    Illustrations["BEAUTY1LARGE"] = "beauty1Large";
    Illustrations["BEAUTY1MEDIUM"] = "beauty1Medium";
    Illustrations["BEAUTY1SMALL"] = "beauty1Small";
    Illustrations["BOOKSTORE1LARGE"] = "bookstore1Large";
    Illustrations["BOOKSTORE1MEDIUM"] = "bookstore1Medium";
    Illustrations["BOOKSTORE1SMALL"] = "bookstore1Small";
    Illustrations["BUILDING01"] = "building01";
    Illustrations["BUILDING02"] = "building02";
    Illustrations["BUILDING_FEST"] = "buildingFest";
    Illustrations["BUTCHER1LARGE"] = "butcher1Large";
    Illustrations["BUTCHER1MEDIUM"] = "butcher1Medium";
    Illustrations["BUTCHER1SMALL"] = "butcher1Small";
    Illustrations["BUTCHER2LARGE"] = "butcher2Large";
    Illustrations["CAR_SERVICE_LARGE"] = "carServiceLarge";
    Illustrations["CAR_SERVICE_MEDIUM"] = "carServiceMedium";
    Illustrations["CAR_SERVICE_SMALL"] = "carServiceSmall";
    Illustrations["CATERER_LARGE"] = "catererLarge";
    Illustrations["CATERER_MEDIUM"] = "catererMedium";
    Illustrations["CATERER_SMALL"] = "catererSmall";
    Illustrations["COFFEESHOP_LARGE"] = "coffeeshopLarge";
    Illustrations["COFFEESHOP_MEDIUM"] = "coffeeshopMedium";
    Illustrations["COFFEESHOP_SMALL"] = "coffeeshopSmall";
    Illustrations["COLLABORATION01"] = "collaboration01";
    Illustrations["COLLABORATION02"] = "collaboration02";
    Illustrations["COLLABORATION03"] = "collaboration03";
    Illustrations["COLLABORATION04"] = "collaboration04";
    Illustrations["COLLABORATION05"] = "collaboration05";
    Illustrations["COLLABORATION06"] = "collaboration06";
    Illustrations["COLLABORATION07"] = "collaboration07";
    Illustrations["COMMUTE01"] = "commute01";
    Illustrations["COMMUTE02"] = "commute02";
    Illustrations["COMMUTE03"] = "commute03";
    Illustrations["CULTURE_LARGE"] = "cultureLarge";
    Illustrations["CULTURE_MEDIUM"] = "cultureMedium";
    Illustrations["CULTURE_SMALL"] = "cultureSmall";
    Illustrations["DEFAULT_LARGE"] = "defaultLarge";
    Illustrations["DEFAULT_MEDIUM"] = "defaultMedium";
    Illustrations["DEFAULT_SMALL"] = "defaultSmall";
    Illustrations["DELIVERY"] = "delivery";
    Illustrations["DEVICE01"] = "device01";
    Illustrations["DEVICE_DESKTOP"] = "deviceDesktop";
    Illustrations["DEVICE_GENERIC"] = "deviceGeneric";
    Illustrations["DEVICE_MOBILE"] = "deviceMobile";
    Illustrations["DEVICE_TABLET_MAN"] = "deviceTabletMan";
    Illustrations["DEVICE_TABLET_WOMAN"] = "deviceTabletWoman";
    Illustrations["DISCOUNT_FOOD"] = "discountFood";
    Illustrations["DISCOUNT_GENERIC"] = "discountGeneric";
    Illustrations["ELECTRONICS_LARGE"] = "electronicsLarge";
    Illustrations["ELECTRONICS_MEDIUM"] = "electronicsMedium";
    Illustrations["ELECTRONICS_SMALL"] = "electronicsSmall";
    Illustrations["EMAIL"] = "email";
    Illustrations["ENGAGEMENT_CONTACT"] = "engagementContact";
    Illustrations["ENGAGEMENT_DONATION"] = "engagementDonation";
    Illustrations["ENTERTAINMENT1LARGE"] = "entertainment1Large";
    Illustrations["ENTERTAINMENT1MEDIUM"] = "entertainment1Medium";
    Illustrations["ENTERTAINMENT1SMALL"] = "entertainment1Small";
    Illustrations["ENTERTAINMENT2LARGE"] = "entertainment2Large";
    Illustrations["FACE_IDOFF"] = "faceIdoff";
    Illustrations["FACE_IDON"] = "faceIdon";
    Illustrations["FASHION1LARGE"] = "fashion1Large";
    Illustrations["FASHION1MEDIUM"] = "fashion1Medium";
    Illustrations["FASHION1SMALL"] = "fashion1Small";
    Illustrations["FASTFOOD_LARGE"] = "fastfoodLarge";
    Illustrations["FASTFOOD_MEDIUM"] = "fastfoodMedium";
    Illustrations["FASTFOOD_SMALL"] = "fastfoodSmall";
    Illustrations["FINGER_OFF"] = "fingerOff";
    Illustrations["FINGER_ON"] = "fingerOn";
    Illustrations["FISHERY_LARGE"] = "fisheryLarge";
    Illustrations["FISHERY_MEDIUM"] = "fisheryMedium";
    Illustrations["FISHERY_SMALL"] = "fisherySmall";
    Illustrations["FLOWER_LARGE"] = "flowerLarge";
    Illustrations["FLOWER_MEDIUM"] = "flowerMedium";
    Illustrations["FLOWER_SMALL"] = "flowerSmall";
    Illustrations["GARDEN_LARGE"] = "gardenLarge";
    Illustrations["GARDEN_MEDIUM"] = "gardenMedium";
    Illustrations["GARDEN_SMALL"] = "gardenSmall";
    Illustrations["GIFT"] = "gift";
    Illustrations["GIFT_CARD_JUMP01"] = "giftCardJump01";
    Illustrations["GIFT_CARD_JUMP02"] = "giftCardJump02";
    Illustrations["GIFT_CARD_JUMP03"] = "giftCardJump03";
    Illustrations["GIFT_CARD_JUMP04"] = "giftCardJump04";
    Illustrations["GIFT_CARD01"] = "giftCard01";
    Illustrations["GIFT_CARD02"] = "giftCard02";
    Illustrations["GIFT_CARD03"] = "giftCard03";
    Illustrations["GIFT_PHONE"] = "giftPhone";
    Illustrations["HEALTH_CHECK_BUILDING"] = "healthCheckBuilding";
    Illustrations["HEALTH_CHECK_MAGNIFYING_GLASS"] = "healthCheckMagnifyingGlass";
    Illustrations["HEALTH_CHECK_MAN_DOCTOR"] = "healthCheckManDoctor";
    Illustrations["HEALTH_CHECK_SYRINGE"] = "healthCheckSyringe";
    Illustrations["HEALTH_CHECK_WOMAN_DOCTOR"] = "healthCheckWomanDoctor";
    Illustrations["HEALTH_CHECKUP_BUILDING"] = "healthCheckupBuilding";
    Illustrations["HEALTH_CHECKUP_DOCTOR"] = "healthCheckupDoctor";
    Illustrations["HOTEL_LARGE"] = "hotelLarge";
    Illustrations["HOTEL_MEDIUM"] = "hotelMedium";
    Illustrations["HOTEL_SMALL"] = "hotelSmall";
    Illustrations["JEWELRY_LARGE"] = "jewelryLarge";
    Illustrations["JEWELRY_MEDIUM"] = "jewelryMedium";
    Illustrations["JEWELRY_SMALL"] = "jewelrySmall";
    Illustrations["JOB_LIFE01"] = "jobLife01";
    Illustrations["JOB_LIFE02"] = "jobLife02";
    Illustrations["JOB_LIFE03"] = "jobLife03";
    Illustrations["JOB_LIFE04"] = "jobLife04";
    Illustrations["JOB_LIFE05"] = "jobLife05";
    Illustrations["JOB_LIFE06"] = "jobLife06";
    Illustrations["JOB_LIFE07"] = "jobLife07";
    Illustrations["JOB_LIFE_DEFAULT"] = "jobLifeDefault";
    Illustrations["KINDERGARTEN_LARGE"] = "kindergartenLarge";
    Illustrations["KINDERGARTEN_MEDIUM"] = "kindergartenMedium";
    Illustrations["KINDERGARTEN_SMALL"] = "kindergartenSmall";
    Illustrations["LOCAL_SHOPS"] = "localShops";
    Illustrations["MEAL_COOKING"] = "mealCooking";
    Illustrations["MEAL_DELIVERY_BIKE"] = "mealDeliveryBike";
    Illustrations["MEAL_LUNCH_BREAK"] = "mealLunchBreak";
    Illustrations["MEAL_TAKEOUT"] = "mealTakeout";
    Illustrations["MEAL01"] = "meal01";
    Illustrations["MEAL02"] = "meal02";
    Illustrations["MEAL03"] = "meal03";
    Illustrations["MEAL04"] = "meal04";
    Illustrations["MEAL05"] = "meal05";
    Illustrations["MEAL06"] = "meal06";
    Illustrations["MEAL07"] = "meal07";
    Illustrations["MEAL08"] = "meal08";
    Illustrations["MEAL09"] = "meal09";
    Illustrations["MEAL10"] = "meal10";
    Illustrations["MEAL11"] = "meal11";
    Illustrations["MEAL12"] = "meal12";
    Illustrations["MINI_MARKET_LARGE"] = "miniMarketLarge";
    Illustrations["MINI_MARKET_MEDIUM"] = "miniMarketMedium";
    Illustrations["MINI_MARKET_SMALL"] = "miniMarketSmall";
    Illustrations["NEW_CARD_NO"] = "newCardNo";
    Illustrations["NEW_CARD_YES"] = "newCardYes";
    Illustrations["NFCOFF"] = "nfcoff";
    Illustrations["NFCON"] = "nfcon";
    Illustrations["NOT_FOUND"] = "notFound";
    Illustrations["OFFICE"] = "office";
    Illustrations["OFFICE_LIFE01"] = "officeLife01";
    Illustrations["OFFICE_LIFE02"] = "officeLife02";
    Illustrations["OFFICE_LIFE03"] = "officeLife03";
    Illustrations["OFFICE_LIFE04"] = "officeLife04";
    Illustrations["OFFICE_LIFE05"] = "officeLife05";
    Illustrations["OFFICE_LIFE06"] = "officeLife06";
    Illustrations["OFFICE_LIFE07"] = "officeLife07";
    Illustrations["OFFICE_LIFE08"] = "officeLife08";
    Illustrations["OFFICE_LIFE09"] = "officeLife09";
    Illustrations["OFFICE_LIFE10"] = "officeLife10";
    Illustrations["ONBOARDING01"] = "onboarding01";
    Illustrations["ONBOARDING02"] = "onboarding02";
    Illustrations["PARENTING01"] = "parenting01";
    Illustrations["PARENTING02"] = "parenting02";
    Illustrations["PARENTING03"] = "parenting03";
    Illustrations["PARENTING04"] = "parenting04";
    Illustrations["PAYMENT_SUCCESS"] = "paymentSuccess";
    Illustrations["PHARMACY_LARGE"] = "pharmacyLarge";
    Illustrations["PHARMACY_MEDIUM"] = "pharmacyMedium";
    Illustrations["PHARMACY_SMALL"] = "pharmacySmall";
    Illustrations["PHONE_CONFIRMATION"] = "phoneConfirmation";
    Illustrations["PLUXEE_COMPANY_ULTRAGREEN"] = "pluxeeCompanyUltragreen";
    Illustrations["PROTECTION_GEL"] = "protectionGel";
    Illustrations["PROTECTION_HEALTH"] = "protectionHealth";
    Illustrations["PROTECTION_MASK"] = "protectionMask";
    Illustrations["RESERVATION"] = "reservation";
    Illustrations["SAVINGS01"] = "savings01";
    Illustrations["SAVINGS02"] = "savings02";
    Illustrations["SCAN_CARD"] = "scanCard";
    Illustrations["SECURITY"] = "security";
    Illustrations["SECURITY_CB"] = "securityCb";
    Illustrations["SECURITY_OFF"] = "securityOff";
    Illustrations["SECURITY_ON"] = "securityOn";
    Illustrations["SHOPS"] = "shops";
    Illustrations["SPORT"] = "sport";
    Illustrations["SPORT1LARGE"] = "sport1Large";
    Illustrations["SPORT1MEDIUM"] = "sport1Medium";
    Illustrations["SPORT1SMALL"] = "sport1Small";
    Illustrations["SPORTWEAR_LARGE"] = "sportwearLarge";
    Illustrations["SPORTWEAR_MEDIUM"] = "sportwearMedium";
    Illustrations["SPORTWEAR_SMALL"] = "sportwearSmall";
    Illustrations["SUPERMARKET_LARGE"] = "supermarketLarge";
    Illustrations["SUPERMARKET_MEDIUM"] = "supermarketMedium";
    Illustrations["SUPERMARKET_SMALL"] = "supermarketSmall";
    Illustrations["THANK_YOU"] = "thankYou";
    Illustrations["TOYSHOP_LARGE"] = "toyshopLarge";
    Illustrations["TOYSHOP_MEDIUM"] = "toyshopMedium";
    Illustrations["TOYSHOP_SMALL"] = "toyshopSmall";
    Illustrations["TRAVEL_LARGE"] = "travelLarge";
    Illustrations["TRAVEL_MEDIUM"] = "travelMedium";
    Illustrations["TRAVEL_SMALL"] = "travelSmall";
    Illustrations["UNLOCK_OFF"] = "unlockOff";
    Illustrations["UNLOCK_ON"] = "unlockOn";
    Illustrations["VOUCHER_PROCESS01"] = "voucherProcess01";
    Illustrations["VOUCHER_PROCESS02"] = "voucherProcess02";
    Illustrations["VOUCHER_PROCESS03"] = "voucherProcess03";
    Illustrations["VOUCHER_PROCESS04"] = "voucherProcess04";
    Illustrations["VOUCHER_PROCESS05"] = "voucherProcess05";
    Illustrations["WELLNESS_TRAVEL"] = "wellnessTravel";
    Illustrations["WIFI_OFF"] = "wifiOff";
    Illustrations["WIFI_ON"] = "wifiOn";
    Illustrations["WORK_LIFE_CALENDAR_NOTIFICATION"] = "workLifeCalendarNotification";
    Illustrations["WORK_LIFE_COUPLE_COUPLE_WITH_BABY"] = "workLifeCoupleCoupleWithBaby";
    Illustrations["WORK_LIFE_COUPLE_COUPLE_WITH_CHILDREN"] = "workLifeCoupleCoupleWithChildren";
    Illustrations["WORK_LIFE_COUPLE_COUPLE"] = "workLifeCoupleCouple";
    Illustrations["WORK_LIFE_SAVE_THE_DATE"] = "workLifeSaveTheDate";
})(Illustrations || (Illustrations = {}));
//# sourceMappingURL=illustrations.types.js.map